import React from "react";
import { AlertCircle, Undo2 } from "lucide-react";
import { FONT, T, focusRing } from "./tokens";

// ===========================================================================
// DraftPill — the amber "Unpublished changes · N sections" status pill plus
// the Publish / Discard actions. Only rendered when there are staged edits.
// The confirm dialog + publish burst live in EditorLayout; this just fires
// onPublish / onDiscard.
// ===========================================================================

export default function DraftPill({ count = 0, sectionCount = 0, onPublish, onDiscard, publishing }) {
  if (count <= 0) return null;
  const secWord = sectionCount === 1 ? "section" : "sections";
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <span
        role="status"
        aria-live="polite"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 7,
          height: 30,
          padding: "0 12px",
          borderRadius: T.radiusFull,
          fontFamily: FONT,
          fontSize: 12.5,
          fontWeight: 600,
          color: "#7a5410",
          background: "rgba(200,146,67,0.14)",
          border: "1px solid rgba(200,146,67,0.4)",
        }}
      >
        <AlertCircle size={13} strokeWidth={2} style={{ color: T.amber }} aria-hidden="true" />
        Unpublished changes · {sectionCount} {secWord}
      </span>

      <button
        type="button"
        onClick={onDiscard}
        aria-label="Discard staged changes"
        title="Discard staged changes"
        onFocus={(e) => (e.currentTarget.style.boxShadow = focusRing.boxShadow)}
        onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          height: 30,
          padding: "0 12px",
          borderRadius: T.radiusFull,
          border: `1px solid ${T.line}`,
          background: "rgba(255,255,255,0.7)",
          color: T.ink2,
          fontFamily: FONT,
          fontSize: 12.5,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        <Undo2 size={13} strokeWidth={2} aria-hidden="true" />
        Discard
      </button>

      <button
        type="button"
        onClick={onPublish}
        disabled={publishing}
        aria-label="Publish changes"
        onFocus={(e) => (e.currentTarget.style.boxShadow = focusRing.boxShadow)}
        onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
        style={{
          height: 30,
          padding: "0 16px",
          borderRadius: T.radiusFull,
          border: `1px solid ${T.blue}`,
          background: T.blue,
          color: "#fff",
          fontFamily: FONT,
          fontSize: 12.5,
          fontWeight: 700,
          cursor: publishing ? "default" : "pointer",
          opacity: publishing ? 0.7 : 1,
          boxShadow: T.shadowSm,
        }}
      >
        {publishing ? "Publishing…" : "Publish"}
      </button>
    </div>
  );
}
